import { Grid, Grid2, Typography } from "@mui/material";
import { Commons } from "../../helper/CommonService";
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from "react";
import { Downloads } from "../../helper/DownloadService";
import { API_HOST, BE_HOST, CONFIG_PENDAFTARAN, FOTO_HOST } from "../../helper/Constant";
import { MainIcon } from "../../helper/MainIcon";

function FotoSantri({ dataSantri, foto }) {
    return (
        <>
            <Grid container>
                <Grid sx={{
                    padding: "5px", textAlign: "center", display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{ padding: "10px", border: "1px solid #000000" }}>
                        <table>
                            <tr>
                                <td align="right">
                                    <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                                </td>
                                <td align="left">
                                    <b>
                                        PSB {dataSantri.tahun_ajaran.tahun_ajaran}
                                        <br></br>
                                        {dataSantri.tujuan.jenjang_tujuan}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={"2"} align="center">
                                    <img style={{ height: "250px" }} src={foto || MainIcon.DefaultFoto()}></img>
                                    <br></br>
                                    <b>
                                        {dataSantri.no_daftar}
                                        <br></br>
                                        {dataSantri.nama}
                                    </b>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Grid>
                <Grid sx={{ padding: "5px" }} xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{ padding: "10px", border: "1px solid #000000" }}>
                        <center>
                            <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                            <br></br>
                            <QRCodeSVG
                                value={dataSantri.no_daftar} // The data to encode in the QR code
                                size={256}   // The size of the QR code
                                bgColor="#ffffff" // Background color
                                fgColor="#000000" // Foreground color
                                level="Q"   // Error correction level (L, M, Q, H)></QRCodeSVG>
                            />
                            <br></br>
                            <b>
                                {dataSantri.no_daftar}
                                <br></br>
                                {dataSantri.nama}
                            </b>
                        </center>

                    </div>
                </Grid>
            </Grid>
        </>
    )
}

export default FotoSantri;